import React from 'react';
import { useParams } from 'react-router-dom';

import { TableFilterIdentitySource } from '~/components/Filters';
import { UncontrolledTable } from '~/components';

const Scheduling = () => {
  const params = useParams();

  return (
    <UncontrolledTable
      name="scheduling"
      className="mx-4"
      endpoint={{
        url: 'data/public/list-view-cs-tbl-identity-source',
        params: {
          patient_uid: params.patient_id,
          identity_column_name: 'MRN',
          'all-data': '1',
        },
      }}
      defaultSorted={[{ id: 'sourceDescription' }]}
      columns={[{
        id: 'sourceDescription',
        Header: 'Reporting Healthcare Institution',
        accessor: 'attributes.sourceDescription',
        Filter: d => <TableFilterIdentitySource {...d} />,
      }, {
        id: 'schedulePhone',
        Header: 'Scheduling Number',
        accessor: 'attributes.schedulePhone',
        cellType: 'tel',
      }]}
    />
  );
};

export default Scheduling;
